import { Button, Toast } from '@insurancemenu/imenu-components-lib';
import FormSpinner from 'components/common/loaders/FormSpinner';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useRootStore } from 'store/rootStore';
import NotificationEmailCard from './NotificationEmailCard';
import { createStyles } from './styles';

const NotificationSettings = observer((): JSX.Element => {
  const classes = createStyles();
  const {
    notificationSettingsStore: {
      loading,
      emails,
      emailsForUser,
      toastInfo: { showToast, toastType, toastMessage },
      closeToast,
      getEmails,
      saveConfigurableEmailsForUser,
    },
  } = useRootStore();

  const convertedEmails = emails.map((email) => toJS(email)).slice();
  const convertedEmailsForUser = emailsForUser.map((type) => toJS(type)).slice();

  useEffect(() => {
    void getEmails();
  }, []);

  const emailsList = convertedEmails.map((email) => (
    <NotificationEmailCard key={email.name} email={email} isChecked={convertedEmailsForUser.includes(email.name)} />
  ));

  return (
    <div className={classes.content}>
      <p className={classes.infoTitle}>
        Selected
        <b className={classes.totalAmount}>
          {convertedEmailsForUser.length}/{emailsList.length}
        </b>
        Emails
      </p>
      <div className={classes.wrapper}>
        <FormSpinner display={loading} />
        <ul className={classes.emailsList}>{emailsList}</ul>
      </div>
      <Button
        color="primary"
        className={classes.saveSettingsButton}
        size="large"
        disabled={loading}
        onClick={(): void => {
          void saveConfigurableEmailsForUser(convertedEmailsForUser);
        }}
      >
        Save Settings
      </Button>
      <Toast show={showToast} onClose={closeToast} colorType={toastType}>
        {toastMessage}
      </Toast>
    </div>
  );
});

export default NotificationSettings;
